<template>
  <div class="modalFooter">
    <b-modal
      id="alerterrormodal"
      ref="my-modal"
      v-model="showalert"
      centered
      :title="title.line1"
      crm_at="modal_alerterrormodal"
      hide-footer
    >
    <div :class="currentLocale">
      <div class="title" crm_at="title_alerterrormodal">{{ title.line2 }}</div>
      <ul>
        <li v-for="(error, index) in modalcontent" :key="index" class="error" crm_at="list_alerterrormodal">
          <div crm_at="list_name">
            {{ error.name }}
          </div>
          <div class="text-blank" crm_at="list_action">
            {{ error.action }}
          </div>
        </li>
      </ul>
    </div>
    </b-modal>
  </div>
</template>

<script>
import CommonMixin from '@/mixin/CommonMixin'
import Locale from '@/helper/Locale.js'
export default {
  components: {},
  mixins: [CommonMixin],
  props: {
    isshowalert: Boolean,
    modalcontent: Array,
    resultalerterror: Boolean,
    title: Object,
  },
  data() {
    return {
      showalert: this.isshowalert,
      showmodal: true,
      canntblank: 'Cannot be blank ',
      currentLocale: Locale.getLocale(),
    }
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      if (modalId == 'alerterrormodal') {
        this.$refs['my-modal'].hide()
        this.$emit('ChangeAlertError', false)
      }
    })
  },
  created() {},
  methods: {
    showModal() {
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.modalcondition.ismodalShow = true
      this.$refs['my-modal'].hide()
    },
    toggleModal() {
      this.$refs['my-modal'].toggle('#toggle-btn')
    },
  },
}
</script>
<style lang="scss">
@import '@/style/_mixin.scss';
#alerterrormodal___BV_modal_outer_ {
  ul {
    padding: 0px;
    li {
      list-style: none;
      .text-blank {
        color: #bc5e5f;
        font-size: 16px;
      }
    }
  }

  .title {
    font-size: 14px;
    color: #666666;
    text-align: center;
  }
  .modal-header {
    background-color: #ffe1e0;
    color: #666666;
    .close {
      font-size: 40px;
      position: absolute;
      top: 0px;
      right: 15px;
    }
  }
  .modal-title {
    font-size: 14px;
    margin: auto;
    @include breakpoint-max(320) {
      font-size: 12px;
    }
  }
  .error {
    font-size: 16px;
    text-align: center;
    margin: 25px;
  }
}
</style>
